import React, { Component } from "react";
import { Auth } from "aws-amplify";
import LoaderButton from "./LoaderButton";

import logo from '../images/LoginWithGoogle.svg';
import hoverLogo from '../images/LoginWithGoogleHover.svg';
import "./GoogleButton.css";

function waitForInit() {
  return new Promise((res, rej) => {
    const hasGoogleLoaded = () => {
      if (window.gapi) {
        res();
      } else {
        setTimeout(hasGoogleLoaded, 300);
      }
    };
    hasGoogleLoaded();
  });
}

export default class GoogleButton extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.handleHover = this.handleHover.bind(this);

    this.state = {
      isLoading: true,
      isHovered: true
    };
  }

  async componentDidMount() {
    await waitForInit();
    this.setState({ isLoading: false });
  }

  checkLoginState = () => {
    var authData = window.auth2.currentUser.get().getAuthResponse(true);
    this.handleResponse(authData);
      //handle success here
  };

  handleClick = () => {
    window.auth2.signIn().then(() => this.checkLoginState()
    , function(rejected) {
       // handle rejection here
    });
  };

  handleError(error) {
    alert(error);
  }

  handleHover() {
    this.setState({
      isHovered: !this.state.isHovered
    });
  }

  async handleResponse(data) {
    const { email, id_token: token, expires_in } = data;
    const expires_at = expires_in * 1000 + new Date().getTime();
    const user = { email };

    this.setState({ isLoading: true });

    try {
      const response = await Auth.federatedSignIn(
        "google",
        { token, expires_at },
        "user@gmail.com"
      );
      this.setState({ isLoading: false });
      this.props.onLogin(response);
    } catch (e) {
      this.setState({ isLoading: false });
      this.handleError(e);
    }
  }

  render() {
    var img;
    if (this.state.isHovered) {
      img = logo;
    } else {
      img = hoverLogo;
    }
    return (
      <div
        className="LoginWithGoogle"
        onMouseEnter={ this.handleHover }
        onMouseLeave={ this.handleHover }
      >
        <img
          className="logo"
          src={img}
          onClick={this.handleClick}
          disabled={this.state.isLoading}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/GoogleButton.js